module.exports = __webpack_public_path__ + "static/media/Morgana.7fa5c5fd.png";